import { render, staticRenderFns } from "./addEmail.vue?vue&type=template&id=16bd2caa&scoped=true"
import script from "./addEmail.vue?vue&type=script&lang=js"
export * from "./addEmail.vue?vue&type=script&lang=js"
import style0 from "./addEmail.vue?vue&type=style&index=0&id=16bd2caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bd2caa",
  null
  
)

export default component.exports